import React from 'react';
import './CustomModal.css';

const CustomModal = ({ open, onClose, maxWidth = "lg", fullWidth = true, children, sx = {} }) => {
    if (!open) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={handleOverlayClick}>
            <div 
                className={`custom-modal custom-modal-${maxWidth} ${fullWidth ? 'custom-modal-fullwidth' : ''}`}
                style={{
                    height: sx['& .MuiDialog-paper']?.height || 'auto',
                    ...sx
                }}
            >
                {children}
            </div>
        </div>
    );
};

const CustomModalTitle = ({ children }) => {
    return (
        <div className="custom-modal-title">
            {children}
        </div>
    );
};

const CustomModalContent = ({ children, sx = {} }) => {
    return (
        <div className="custom-modal-content" style={sx}>
            {children}
        </div>
    );
};

const CustomModalActions = ({ children }) => {
    return (
        <div className="custom-modal-actions">
            {children}
        </div>
    );
};

export { CustomModal, CustomModalTitle, CustomModalContent, CustomModalActions };